import { Container } from 'ui/components/primitives';
import { styled, theme, utils } from 'ui/theme';

export const Checkout = {
  Container: styled(Container)`
    display: 'grid';
    gap: ${theme.space[2]};

    &[data-margin-top='sp-4'] {
      ${utils.media.max('l')`
        margin-top: ${theme.space[4]};
      `}
    }
  `,

  Component: styled.div`
    margin: 0 auto;
    width: 100%;
  `,
};
